import { useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { POSTS } from "@/data/posts";

export default function BlogList() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="blog-page" className="min-h-screen bg-[#FAF9F6]">
      <header className="border-b border-slate-200 bg-white/70 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-5">
          <span className="font-display text-lg font-extrabold tracking-tight text-slate-900">
            SOCIFY<span className="text-[#1D4ED8]">.</span>
            <span className="ml-2 font-mono-sig text-[10px] font-bold uppercase tracking-[0.25em] text-slate-400">Blog</span>
          </span>
          <a
            data-testid="blog-back-link"
            href="/"
            className="group flex items-center gap-2 rounded-full border border-slate-300 px-4 py-2 text-xs font-bold text-slate-700 transition-colors hover:bg-slate-900 hover:text-white"
          >
            <ArrowLeft className="h-3.5 w-3.5 transition-transform group-hover:-translate-x-0.5" />
            Volver a la web
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-6 py-16">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}>
          <p className="mb-3 font-mono-sig text-xs font-bold uppercase tracking-[0.3em] text-[#1D4ED8]">
            Consejos para negocios locales
          </p>
          <h1 className="mb-14 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
            Marketing que se entiende<span className="text-[#00F0FF]">.</span>
          </h1>
        </motion.div>

        <div className="space-y-5">
          {POSTS.map((post, i) => (
            <motion.a
              key={post.slug}
              data-testid={`blog-card-${i + 1}`}
              href={`/blog/${post.slug}`}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
              className="group flex flex-col justify-between gap-4 rounded-3xl border border-slate-200 bg-white p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-2xl hover:shadow-slate-900/10 sm:flex-row sm:items-center"
            >
              <div>
                <div className="mb-3 flex flex-wrap items-center gap-3">
                  <span className="rounded-full bg-[#1D4ED8]/10 px-3 py-1 font-mono-sig text-[10px] font-bold uppercase tracking-widest text-[#1D4ED8]">
                    {post.category}
                  </span>
                  <span className="font-mono-sig text-[10px] uppercase tracking-widest text-slate-400">
                    {new Date(post.date).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" })} · {post.readTime}
                  </span>
                </div>
                <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-900 transition-transform duration-500 group-hover:translate-x-1">
                  {post.title}
                </h2>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-500">{post.excerpt}</p>
              </div>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center self-end rounded-full border border-slate-300 transition-all duration-500 group-hover:border-slate-900 group-hover:bg-slate-900 group-hover:text-[#00F0FF] sm:self-center">
                <ArrowUpRight className="h-5 w-5" />
              </span>
            </motion.a>
          ))}
        </div>
      </main>
    </div>
  );
}
